// src/components/HeroBanner/HeroBanner.jsx
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";

import {
  FaInfoCircle,
  FaChalkboardTeacher,
  FaUserGraduate,
  FaBriefcase,
  FaCalendarAlt,
  FaStore,
  FaUserTie,
  FaSuitcase,
} from "react-icons/fa";

import "./HeroBanner.css";

const bannerImages = [
  "/images/home/banners/banner-homepage-01.webp",
  "/images/home/banners/banner-homepage-02.webp",
  "/images/home/banners/banner-homepage-03.webp",
  "/images/home/banners/banner-homepage-04.webp",
  "/images/home/banners/banner-homepage-05.webp",
];

const navItems = [
  { label: "Giới thiệu", icon: FaInfoCircle },
  { label: "Giảng viên", icon: FaChalkboardTeacher },
  { label: "Đào tạo", icon: FaUserGraduate },
  { label: "Ngành nghề", icon: FaBriefcase },
  { label: "Khai Giảng", icon: FaCalendarAlt },
  { label: "Cửa hàng", icon: FaStore },
  { label: "Tuyển dụng", icon: FaUserTie },
  { label: "Thực tập", icon: FaSuitcase },
];

const HeroBanner = () => {
  const handleNavClick = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  const slugify = (text) =>
    text
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/đ/g, "d")
      .replace(/Đ/g, "d")
      .toLowerCase()
      .replace(/\s+/g, "-");

  return (
    <section className="hero-banner">
      {/* Swiper chỉ để đổi ảnh nền */}
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        loop
        slidesPerView={1}
        pagination={{ clickable: true }}
        className="hero-banner__swiper"
      >
        {bannerImages.map((image, index) => (
          <SwiperSlide key={index}>
            <div
              className="hero-banner__slide"
              style={{ backgroundImage: `url(${image})` }}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Nội dung cố định trên banner */}
      <div className="hero-banner__content-fixed">
        <div className="hero-banner__headline">
          <div className="hero-banner__col-left">
            <span className="hero-banner__headline-large">Định</span>
          </div>
          <div className="hero-banner__col-right">
            <span className="hero-banner__headline-small">hình đam mê</span>
            <span className="hero-banner__headline-small">hướng tương lai</span>
          </div>
        </div>

        <h2 className="hero-banner__title-fixed">
          Đào Tạo Và Cung Ứng Nguồn Nhân Lực Chất Lượng Cao
        </h2>
        <nav className="hero-banner__nav">
          <ul>
            {navItems.map(({ label, icon: Icon }) => (
              <li key={label}>
                <button
                  onClick={() => handleNavClick(slugify(label))}
                  type="button"
                >
                  <div className="hero-banner__nav-icon-wrapper">
                    <Icon className="hero-banner__nav-icon" />
                  </div>
                  <span>{label}</span>
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </section>
  );
};

export default HeroBanner;
